import React from 'react';

type Props = {
  show?: boolean;
  type?: string;
  url?: string;
};

function Screen(props: Props) {
  if (props.show && props.url && props.type === 'screen') {
    return (
      <div className="screen-overlay">
        <iframe
          title="Screen iframe"
          src={props.url}
          width="100%"
          height="100%"
        />
      </div>
    );
  }
  return null;
}

export default Screen;
